/**
 * Address completion script
 */

let xhrHandles = {};
let debouncers = {};

/**
 * Handle key up for an address completion input
 * @param {jQuery} $input
 */
const handleKeyUp = function($input) {
    let properties = $input.data('ac-properties');
    let index      = $input.data('ac-index');
    if (properties === undefined || index === undefined) {
        return;
    }

    fetchCompletion(index);
};

/**
 * Update input entries for address completion with a specific index
 * @param {int} index
 */
const getInput = function(index) {
    let input = {};
    $('[name][data-ac-properties*="input"][data-ac-index="' + index + '"]').each(function() {
        let properties = $(this).data('ac-properties');
        let $field     = $(this);
        properties.forEach(function(p) {
            if (p.indexOf('input') !== 0) {
                return;
            }

            // Undefined or empty inputs are not valid
            if ($field.val() === undefined || $field.val() === null || $field.val().length === 0) {
                return;
            }
            input[p] = $field.val();
        });
    });
    return input;
};

/**
 * Fetch completion for an index
 * @param {int} index
 */
const fetchCompletion = function(index) {
    if (window._address_completion === undefined) {
        return;
    }

    // Update all input entries to ensure up-to-date info
    let inputs = getInput(index);
    if (!inputs || Object.keys(inputs).length === 0) {
        return;
    }

    // Check if all minimum inputs are not empty
    let hasMinimumInput = true;
    window._address_completion.minimumInputs.forEach(function(p) {
        if (inputs[p] === undefined || inputs[p].length === 0) {
            hasMinimumInput = false;
        }
    });
    if (!hasMinimumInput) {
        return;
    }

    // Abort the current XHR
    if (xhrHandles[index] !== undefined) {
        xhrHandles[index].abort();
    }

    // Initialize collected variables
    let $addressFields     = $('[name][data-ac-index="' + index + '"]');
    let $outputsOnly       = [];
    let $outputAndInput    = [];
    let $allOutputs        = [];
    let $allInputs         = [];
    let inputOutputMapping = {};
    let $outputAsText      = $('[data-ac-text="' + index + '"]');

    // Collect address IO fields into their appropriate variables
    $addressFields.each(function() {
        let $field     = $(this);
        let properties = $field.data('ac-properties');
        let hasInput   = false;
        let hasOutput  = false;
        properties.forEach(function(p) {
            hasInput  = p.indexOf('input') === 0 || hasInput;
            hasOutput = p.indexOf('output') === 0 || hasOutput;
            if (inputOutputMapping[p] === undefined) {
                inputOutputMapping[p] = [];
            }
            inputOutputMapping[p].push($field);
        });
        if (hasOutput) {
            $allOutputs.push($field);
            if (hasInput) {
                $outputAndInput.push($field);
            } else {
                $outputsOnly.push($field);
            }
        }
        if (hasInput) {
            $allInputs.push($field);
        }
    });
    // Transform arrays to jQuery sets
    $outputsOnly    = $($outputsOnly).map($.fn.toArray);
    $outputAndInput = $($outputAndInput).map($.fn.toArray);
    $allOutputs     = $($allOutputs).map($.fn.toArray);
    $allInputs      = $($allInputs).map($.fn.toArray);

    // Set loading to the correct containers
    if ($outputAsText.length > 0) {
        $outputAsText.addClass('loading');
        $outputsOnly.closest('.form-group').addClass('d-none');
    } else {
        $outputsOnly.blur().prop('disabled', true);
        $outputsOnly.closest('.form-group').addClass('loading no-blur');
    }

    // Determine what the submit button for the entire form is to prevent submission while
    // fetching address completion
    let $submitButton = $outputsOnly.closest('form').find('button[type="submit"]');
    $submitButton.prop('disabled', true);

    xhrHandles[index] = $.ajax(window._address_completion.endpoint, {
        method:   'GET',
        data:     $.extend(inputs, {_Token: window._address_completion._Token}),
        success:  function(data) {
            // Disable all visible outputs and hide them if needed
            // Enable hidden inputs if needed
            $outputsOnly.filter(':not([type="hidden"])').prop('disabled', true);
            $outputsOnly.filter('[type="hidden"]').prop('disabled', false);
            $outputsOnly.filter('[data-ac-hide]').closest('.form-group').addClass('d-none');

            // Set address properties to their respective outputs, reset them first
            $allOutputs.val('');
            for (let outputProperty in data.address) {
                if (!data.address.hasOwnProperty(outputProperty) || data.address[outputProperty] === null || data.address[outputProperty].length === 0) {
                    continue;
                }
                if (outputProperty === 'as_text') {
                    $outputAsText.html(data.address[outputProperty]);
                }
                if (inputOutputMapping[outputProperty] !== undefined) {
                    inputOutputMapping[outputProperty] = $(inputOutputMapping[outputProperty]).map($.fn.toArray);
                    inputOutputMapping[outputProperty].each(function() {
                        let $outputField = $(this);
                        $outputField.val($outputField.val() + data.address[outputProperty]);
                    });
                }
            }
        },
        error:    function() {
            // Ensure all inputs and output are enabled and shown if the call fails or no address is found
            $outputsOnly.filter('[data-ac-hide]').closest('.form-group').removeClass('d-none');
            $outputAsText.empty();
            $allOutputs.prop('disabled', false);
            if ($(':focus').length === 0) {
                $outputsOnly.filter(':not([type="hidden"]):visible').first().focus();
            }
        },
        complete: function() {
            // Remove loading classes
            $outputAsText.removeClass('loading');
            $outputsOnly.closest('.form-group').removeClass('loading no-blur');

            // Enable submission button
            $submitButton.prop('disabled', false);
        },
    });
};

// Export initialization
export default {
    initialize: function() {
        $(document).on('keyup change blur', '[name][data-ac-properties*="input"]', function() {
            let $field = $(this);
            let index  = $field.data('ac-index');
            if (index !== undefined) {
                // Only start timeout if the value of the input actually changed
                // with regard to the last time this was called
                let newValue = $field.val();
                if (newValue === $field.data('old-value')) {
                    return;
                }
                $field.data('old-value', newValue);

                if (debouncers[index]) {
                    clearTimeout(debouncers[index]);
                }
                debouncers[index] = setTimeout(function() {
                    handleKeyUp($field);
                }, 250);
            }
        });

        // When address completion fields are auto completed, they need to be automatically updated
        $(document).ready(function() {
            $('[name][data-ac-properties*="input"]').trigger('change');
        });
    },
};


// WEBPACK FOOTER //
// ./build/script/src/components/address_completion.js